import AppErrorBounds from './appErrorBoundary'

export default AppErrorBounds
